import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory('qrcodeMgm'),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: 'qrcode'
    },
    {
      path: '/qrcode',
      name: 'qrcode',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/QrcodeMgm.vue')
    },
    {
      path: '/qrcodeURL',
      name: 'qrcodeURL',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/QrcodeURL.vue')
    },
    {
      path: '/error',
      name: 'error',
      component: () => import(/* webpackChunkName: "about" */ './views/Error.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

export default router
